import Header from "../components/Header";
import Footer from "../components/Footer";

function DatenschutzPage() {
  return (
    <>
      <Header />

      <main className="relative z-10 max-w-4xl mx-4 md:mx-auto pt-20 md:pt-24">
        <section className="glass-card p-6 md:p-10 text-left text-slate-800">
          <p className="uppercase tracking-[0.16em] text-xs font-bold text-cyan-700 mb-3">Rechtliches</p>
          <h1 className="text-3xl md:text-4xl font-black text-slate-900 mb-6">Datenschutzerklaerung</h1>

          <div className="space-y-6 leading-relaxed">
            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">1. Verantwortlicher</h2>
              <p>Marko Piljak</p>
              <p>Softwareentwicklung und Prozessoptimierung</p>
              {/* <p>Strasse und Hausnummer: BITTE ERGAENZEN</p> */}
              {/* <p>PLZ Ort: BITTE ERGAENZEN</p> */}
              <p>E-Mail: markopiljak@web.de</p>
              <p>Telefon: +4915786549347</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">2. Allgemeine Hinweise zur Datenverarbeitung</h2>
              <p>
                Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfaehigen Website
                sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung erfolgt auf Grundlage der DSGVO.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">3. Hosting</h2>
              <p>
                Diese Website wird bei einem externen Hosting-Dienstleister betrieben. Dabei koennen Verbindungsdaten
                (z. B. IP-Adressen, Zeitpunkte von Zugriffen, Browserinformationen) in Server-Logfiles verarbeitet werden,
                um einen stabilen und sicheren Betrieb zu gewaehrleisten.
              </p>
              <p className="mt-2">
                Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherem Betrieb der Website).
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">4. Kontaktformular</h2>
              <p>
                Wenn Sie uns ueber das Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular
                inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und fuer den Fall
                von Anschlussfragen bei uns gespeichert und verarbeitet.
              </p>
              <p className="mt-2">
                Verarbeitete Daten: Name, Unternehmen (optional), E-Mail-Adresse, Nachricht.
              </p>
              <p className="mt-2">
                Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Kommunikation) bzw. Art. 6 Abs. 1 lit. f DSGVO
                (berechtigtes Interesse an effizienter Kommunikation).
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">5. Speicherdauer</h2>
              <p>
                Wir speichern personenbezogene Daten nur so lange, wie dies fuer die jeweiligen Zwecke erforderlich ist
                oder gesetzliche Aufbewahrungsfristen bestehen.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">6. Weitergabe von Daten</h2>
              <p>
                Eine Weitergabe an Dritte erfolgt nur, wenn dies zur Vertragsabwicklung erforderlich ist,
                eine gesetzliche Verpflichtung besteht oder Sie eingewilligt haben.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">7. Ihre Rechte</h2>
              <p>
                Sie haben das Recht auf Auskunft, Berichtigung, Loeschung, Einschraenkung der Verarbeitung,
                Datenuertragbarkeit sowie Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten.
              </p>
              <p className="mt-2">
                Zudem haben Sie ein Beschwerderecht bei einer Datenschutz-Aufsichtsbehoerde.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">8. SSL- bzw. TLS-Verschluesselung</h2>
              <p>
                Diese Seite nutzt aus Sicherheitsgruenden und zum Schutz der Uebertragung vertraulicher Inhalte
                eine SSL- bzw. TLS-Verschluesselung.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">9. Stand</h2>
              <p>Stand dieser Datenschutzerklaerung: April 2026.</p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default DatenschutzPage;
